import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React from "react";
import { AuditToggleButtonContainer } from "../../Feeds.style";
import { Theme } from "@orijinworks/frontend-commons";
import UnleashProvider from "../../../../core/unleash/unleashProvider";
import { UnleashService } from "../../../../services";


const UnleashFlagEnabled = ({ isDisabled, selectedType, onTypeChange }) => {
    return (
        <ToggleButtonGroup
        value={selectedType}
        color="primary"
        exclusive
        aria-label="Audit type filter"
        onChange={onTypeChange}
        role="radiogroup"
    >

            <ToggleButton
                className="toggle-button-left"
                value={"Conversations"}
                disabled={isDisabled}
                role="radio"
                aria-checked={selectedType === 'Conversations'}
                aria-label="Show my conversations audit"
            >
                Conversations
            </ToggleButton>
            <ToggleButton
                className="toggle-button-middle"
                value={"Announcements"}
                disabled={isDisabled}
                role="radio"
                aria-checked={selectedType === 'Announcements'}
                aria-label="Show all announcements audit"
            >
                Announcements
            </ToggleButton>
            <ToggleButton
                className="toggle-button-right"
                value={"Feed-History"}
                disabled={isDisabled}
                role="radio"
                aria-checked={selectedType === 'Feed-History'}
                aria-label="Show all feed history audit"
            >
                Feeds History
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

const UnleashFlagDisabled = ({ isDisabled, selectedType, onTypeChange }) => {
    return (
         <ToggleButtonGroup
                    value={selectedType}
                    color="primary"
                    exclusive
                    aria-label="Audit type filter"
                    onChange={onTypeChange}
                    role="radiogroup"
                >
            <ToggleButton
                className="toggle-button-left"
                value={"Conversations"}
                disabled={isDisabled}
                role="radio"
                aria-checked={selectedType === 'Conversations'}
                aria-label="Show my conversations audit"
            >
                Conversations
            </ToggleButton>
            <ToggleButton
                className="toggle-button-right"
                value={"Announcements"}
                disabled={isDisabled}
                role="radio"
                aria-checked={selectedType === 'Announcements'}
                aria-label="Show all announcements audit"
            >
                Announcements
            </ToggleButton>
            </ToggleButtonGroup>
    );
};
export const AuditToggleButton = ({ isDisabled, selectedType, onTypeChange }) => {
    return (
        <Theme>
            <AuditToggleButtonContainer>
                    <UnleashProvider
                    fallbackComponent={<UnleashFlagDisabled isDisabled={isDisabled} selectedType={selectedType} onTypeChange={onTypeChange} />}
                    flagName={UnleashService.FLAGS.AUDIT_FEED_HISTORY}>
                        <UnleashFlagEnabled isDisabled={isDisabled} selectedType={selectedType} onTypeChange={onTypeChange} />
                    </UnleashProvider>
            </AuditToggleButtonContainer>
        </Theme>
    );
};